import React from 'react';
import { Icon } from '@iconify/react';

const Modal = ({ 
  isOpen, 
  onClose, 
  type = 'info', 
  title, 
  message, 
  onConfirm, 
  showCancel = true,
  confirmText = 'OK',
  cancelText = 'Cancel',
  children
}) => {
  if (!isOpen) return null;

  const getIcon = () => {
    switch (type) {
      case 'success':
        return <Icon icon="heroicons:check-circle-20-solid" className="w-12 h-12 text-green-500" />;
      case 'error':
        return <Icon icon="heroicons:x-circle-20-solid" className="w-12 h-12 text-red-500" />;
      case 'warning':
        return <Icon icon="heroicons:exclamation-triangle-20-solid" className="w-12 h-12 text-yellow-500" />;
      default:
        return <Icon icon="heroicons:information-circle-20-solid" className="w-12 h-12 text-blue-500" />;
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-[9999] transition-all duration-300">
      <div className="bg-white dark:bg-dark rounded-2xl max-w-md w-full transform transition-all duration-300 scale-100 shadow-2xl">
        <div className="p-6">
          <div className="flex flex-col items-center text-center mb-6">
            <div className="mb-4">
              {getIcon()}
            </div>
            <h3 className="text-xl font-bold text-gray-900 dark:text-gray-200 mb-2">
              {title}
            </h3>
            {typeof message === 'string' ? (
              <p className="text-gray-600 dark:text-gray-400 text-sm">
                {message}
              </p>
            ) : (
              message
            )}
            {children}
          </div>

          <div className="flex space-x-3">
            {onConfirm && (
              <button
                onClick={onConfirm}
                className={`flex-1 py-3 rounded-xl font-semibold transition-all duration-300 text-sm transform hover:-translate-y-0.5 ${
                  type === 'success' ? 'bg-green-500 text-white hover:bg-green-600' :
                  type === 'error' ? 'bg-red-500 text-white hover:bg-red-600' :
                  type === 'warning' ? 'bg-yellow-500 text-white hover:bg-yellow-600' :
                  'bg-blue-500 text-white hover:bg-blue-600'
                }`}
              >
                {confirmText}
              </button>
            )}
            {showCancel && (
              <button
                onClick={onClose}
                className="flex-1 bg-gray-200 dark:bg-dark text-gray-700 dark:text-gray-300 py-3 rounded-xl font-semibold hover:bg-gray-300 dark:hover:bg-gray-600 transition-all duration-300 text-sm"
              >
                {cancelText}
              </button>
            )}
            {!showCancel && !onConfirm && (
              <button
                onClick={onClose}
                className="flex-1 bg-blue-500 text-white py-3 rounded-xl font-semibold hover:bg-blue-600 transition-all duration-300 text-sm"
              >
                {confirmText}
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Modal;